export const deleteMockArrays = (wizardState, keys = []) => {
    keys.forEach((key) => {
        const array = wizardState[key] || [];
        if (array.length === 1 && array[0].name === "") {
            delete wizardState[key];
        }
    })
    return wizardState;
}